import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

export interface DropZoneLegendEntry {
  /** Drop Zone (category) name. */
  name: string;
  /** Fill color matching the fixtures on the floorplan. */
  color: string;
  /** Number of fixtures assigned to this Drop Zone. */
  fixtureCount: number;
}

export interface DropZoneLegendProps {
  entries: DropZoneLegendEntry[];
}

/**
 * Legend for GFC Drop Zone editing: maps each Drop Zone's fixture color to its
 * name and assigned-fixture count. Shown alongside the floorplan while assigning
 * fixtures so the color coding is self-explanatory.
 */
const DropZoneLegend: React.FC<DropZoneLegendProps> = ({ entries }) => (
  <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
    <Box width="280px" spacingInset="200">
      <Column spacing="200">
        <Text type="h100">Drop Zones</Text>
        {entries.map((entry) => (
          <Row key={entry.name} spacing="200" alignmentVertical="center">
            <div
              style={{
                width: '14px',
                height: '14px',
                backgroundColor: entry.color,
                borderRadius: '3px',
                border: '1px solid #999',
                flexShrink: 0,
              }}
              aria-hidden="true"
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <Text breakWord>{entry.name}</Text>
            </div>
            <Text type="b200" color="secondary">
              {entry.fixtureCount}
            </Text>
          </Row>
        ))}
      </Column>
    </Box>
  </div>
);

export default DropZoneLegend;
